export const RULES_TEXTAREA_MAX_LENGTH = 3000;

// context
export const FORM_CONTEXT_VALUE_CREATE = "create";
export const FORM_CONTEXT_VALUE_DUPLICATE = "duplicate";
export const FORM_CONTEXT_VALUE_UPDATE = "update";
